import ensureCsrf from 'chairisher/util/csrf';

/**
 * Clears email and password fields in case they were (partially) filled out in form, sets is_provider_initial_attempt,
 * then CSRF-prepares it and submits it so bound submit handlers run.
 *
 * @param {HTMLElement} formEl
 */
export function submitFormViaSocialAuth(formEl) {
    const form = formEl;
    form.querySelector('[name="email"]').value = '';
    // some flows like marketing modal doesn't have a password field
    const passwordField = form.querySelector('[name="password"]');
    if (passwordField) {
        passwordField.value = '';
    }
    form.querySelector('[name="is_provider_initial_attempt"]').value = 1;
    ensureCsrf();
    form.requestSubmit();
}
